const units = {}
export default units

const RED_MONSTER = {
    "element": "fire",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 20, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

const BLUE_MONSTER = {
    "element": "water",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 20, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

const GREEN_MONSTER = {
    "element": "earth",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 20, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

const DEFAULT_MONSTER = {
    "maxhealth": 1000,
    "defense": 100,
    "resistance": 100,
    "moverange": 2,

    "stack": 1,

    "affiliation": "bad",
    "state": "aggroed",
    "role": "monster",

    "title": "Unknown Entity",

    "properties": [
        "no healthbar",
        "blacked out until aggroed"
    ],
    "power": 10,
    "primaryItem": {
        "attacktype": "steel",
        "attackrange": 1,
        "skillKeys": ["inflict-damage"],
    },
    "moveAnimationSpeed": 3,
    "moveAnimationType": "line",

    "spriteSize": "4x3",
    "weaponImageKey": "hidden",
    "weaponAudioKey": "Unit:Attack:Monster",
    "animationKey": "bob",
}

units["book/undead"] = {
    ...DEFAULT_MONSTER,
    ...GREEN_MONSTER,
    "state": "aggroed",
    "movetype": "cumbersome",
    "power": 20,
    "moverange": 2,
    "stimuli": {
        "brandish:mirror": "passive",
        "unbrandish:mirror": "aggroed"
    },
    "deathCondition": {
        "silver": [{x: 0, y: -1, z: 0}, {x: 1, y: 1, z: 0}],
    },
}

units["book/eyebeast"] = {
    ...DEFAULT_MONSTER,
    ...GREEN_MONSTER,
    "state": "unpredictable-but-defensive",
    "movetype": "mobile",
    "power": 30,
    "moverange": 1,
    "stimuli": {
        "brandish:lantern": "afraid",
        "unbrandish:lantern": "unpredictable-but-defensive",
    },
    "deathCondition": {
        "salt": [{x: 0, y: -1, z: 0}, {x: 0, y: 1, z: 0}]
    },
}

units["book/werewolf"] = {
    ...DEFAULT_MONSTER,
    ...GREEN_MONSTER,
    "state": "aggroed",
    "movetype": "cumbersome",
    "power": 20,
    "moverange": 3,
    "stimuli": {
        "brandish:mirror": "afraid",
        "unbrandish:mirror": "aggroed",
    },
    "deathCondition": {
        "silver": [{x: 0, y: 1, z: 0}],
    },
}

units["book/manmoth"] = {
    ...DEFAULT_MONSTER,
    ...GREEN_MONSTER,
    "state": "passive",
    "movetype": "incorporeal",
    "power": 10,
    "moverange": 3,
    "stimuli": {
        "brandish:lantern": "aggroed",
        "unbrandish:lantern": "passive"
    },
    "deathCondition": {
        "sulfur": [{x: 1, y: 0, z: 0}],
        "silver": [{x: 0, y: 1, z: 0}]
    },
}

units["book/vampire"] = {
    ...DEFAULT_MONSTER,
    ...RED_MONSTER,
    "state": "aggroed",
    "movetype": "mobile",
    "power": 20,
    "moverange": 2,
    "stimuli": {
        "brandish:crucifix": "afraid",
        "unbrandish:crucifix": "aggroed"
    },
    "deathCondition": {
        "silver": [{x: 1, y: -1, z: 0}, {x: -1, y: 1, z: 0}],
    },
}

units["book/angel"] = {
    ...DEFAULT_MONSTER,
    ...BLUE_MONSTER,
    "state": "aggroed",
    "movetype": "mobile",
    "power": 10,
    "moverange": 3,
    "stimuli": {
        "brandish:lantern": "passive",
        "unbrandish:lantern": "aggroed"
    },
    "deathCondition": {
        "sulfur": [{x: -1, y: 0, z: 0}, {x: 0, y: -1, z: 0}, {x: 1, y: 0, z: 0}],
    },
}

units["book/ooze"] = {
    ...DEFAULT_MONSTER,
    ...GREEN_MONSTER,
    "state": "unpredictable-but-defensive",
    "movetype": "incorporeal",
    "power": 10,
    "moverange": 1,
    "stimuli": {
        "brandish:lantern": "afraid",
        "unbrandish:lantern": "unpredictable-but-defensive"
    },
    "deathCondition": {
        "sulfur": [{x: -1, y: 0, z: 0}],
    },
}

units["book/ghost"] = {
    ...DEFAULT_MONSTER,
    ...BLUE_MONSTER,
    "state": "aggroed",
    "movetype": "incorporeal",
    "power": 0.01,
    "moverange": 1,
    "stimuli": {
        "brandish:crucifix": "passive",
        "unbrandish:crucifix": "aggroed"
    },
    "deathCondition": {
        "salt": [{x: 1, y: -1, z: 0}],
    },
}

units["book/demon"] = {
    ...DEFAULT_MONSTER,
    ...RED_MONSTER,
    "state": "aggroed",
    "movetype": "cumbersome",
    "power": 30,
    "moverange": 3,
    "stimuli": {
        "brandish:crucifix": "unpredictable",
        "unbrandish:crucifix": "aggroed"
    },
    "deathCondition": {
        "sulfer": [{x: 1, y: -1, z: 0}],
        "silver": [{x: 1, y: 1, z: 0}],
        "salt": [{x: -1, y: 1, z: 0}]
    },
}


units["book/terrain"] = {
    "type": "thing",
    "affiliation": "none",
    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/book-tactics/ludum-difficultterrain-wood-2.png")},
            ],
        },
    },
}
